import { render, staticRenderFns } from "./SetCookiesPage.vue?vue&type=template&id=1c1528dd&"
import script from "./SetCookiesPage.vue?vue&type=script&lang=js&"
export * from "./SetCookiesPage.vue?vue&type=script&lang=js&"
import style0 from "./SetCookiesPage.vue?vue&type=style&index=0&id=1c1528dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports